import { MessageCircle } from 'lucide-react'

export default function EmptyState() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
        <MessageCircle className="h-8 w-8 text-primary" />
      </div>
      <div>
        <h2 className="text-xl font-semibold">Ask Kaiyo a question</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Get answers about healthcare regulations, compliance, and policies.
        </p>
      </div>
    </div>
  )
}
